import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-level"]
const _hoisted_2 = ["src", "alt", "width", "height"]
const _hoisted_3 = ["src", "alt"]

import { type PropType, computed } from "vue";
import {
    isDropdownContainer,
    isMulticolumnDropdownContainer,
    type MenuItem,
    type PatchedMenuItem,
} from "./menu-item";
import Items from "./items.vue";
import FadeAndSlide from "../../shared/FadeAndSlide.vue";
import { isNullOrWhitespace } from "../../../../shared/utils/string";
import { createNotoImgUrlForSymbol, extractEmojiData } from "./patch-emoji";


export default /*@__PURE__*/_defineComponent({
  __name: 'item',
  props: {
    menuItem: {
        type: Object as PropType<PatchedMenuItem>,
    },
    mobile: Boolean,
    pseudo: Boolean,
    first: Boolean,
    last: Boolean,
    dropdownItem: Boolean,
    columnItem: Boolean,
    showSubItemsInColumn: Boolean,
    expanded: Boolean,
    bold: Boolean,
    smaller: Boolean,
    name: String,
    disableItems: Boolean,
    level: {
        type: Number,
        required: true,
    },
},
  emits: ["click", "expand", "collapse"],
  setup(__props, { emit: __emit }) {

const props = __props;

const dropdown = computed(() => {
    return (
        !props.disableItems &&
        !props.showSubItemsInColumn &&
        isDropdownContainer(props.menuItem, props.mobile)
    );
});

const link = computed(() => {
    if (dropdown.value) {
        return "#";
    }
    return props.menuItem?.link ?? "#";
});

const isClickable = computed(
    () =>
        dropdown.value ||
        (typeof props.menuItem?.link == "string" &&
            props.menuItem.link.trim() != "")
);

const target = computed(() => {
    return props.menuItem != null && !isNullOrWhitespace(props.menuItem.target)
        ? props.menuItem.target
        : undefined;
});

const emit = __emit;

function isBlank(menuItem: MenuItem | undefined) {
    // return false, because undefined means filler item
    if (menuItem == null) return false;
    if (menuItem.name.trim() == "") {
        return true;
    }
    return false;
}

function clickLink(event: Event) {
    if (props.pseudo) {
        emit("click");
        event.preventDefault();
        return;
    }
    if (dropdown.value) {
        if (props.expanded) {
            emit("collapse");
        } else {
            emit("expand");
        }
        event.preventDefault();
        return;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass([
            _ctx.$style['menu-item'],
            __props.first ? _ctx.$style['menu-item-first'] : '',
            __props.last ? _ctx.$style['menu-item-last'] : '',
            __props.mobile ? _ctx.$style['mobile-item'] : _ctx.$style['desktop-item'],
            dropdown.value ? _ctx.$style['with-dropdown-items'] : '',
            __props.dropdownItem && __props.showSubItemsInColumn
                ? _ctx.$style['column-list-item']
                : '',
            __props.dropdownItem ? _ctx.$style['dropdown-item'] : '',
            __props.columnItem ? _ctx.$style['column-item'] : '',
            __props.expanded ? _ctx.$style['expanded'] : _ctx.$style['collapsed'],
            __props.bold ? _ctx.$style['bold'] : '',
            __props.smaller ? _ctx.$style['smaller'] : '',
            isBlank(__props.menuItem) ? _ctx.$style['blank'] : '',
            __props.menuItem?.customClassName,
        ]),
    "data-level": __props.level
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(isClickable.value ? 'a' : 'span'), {
      href: link.value,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (clickLink($event))),
      class: _normalizeClass(_ctx.$style['menu-item-link']),
      target: target.value
    }, {
      default: _withCtx(() => [
        (__props.menuItem?.iconUrl != null)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: __props.menuItem.iconUrl,
              alt: __props.menuItem.name,
              "data-no-block": "",
              class: _normalizeClass(_ctx.$style['menu-item-icon']),
              width: __props.menuItem.iconWidth,
              height: __props.menuItem.iconHeight
            }, null, 10 /* CLASS, PROPS */, _hoisted_2))
          : _createCommentVNode("v-if", true),
        _createElementVNode("span", {
          class: _normalizeClass(_ctx.$style['menu-item-text'])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(extractEmojiData)(
                        __props.menuItem?.name ?? __props.name ?? ''
                    ), (entry) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (entry.type === 'text')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(entry.content), 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
                : (entry.type == 'emoji')
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _unref(createNotoImgUrlForSymbol)(entry.content),
                      width: "16",
                      height: "16",
                      "data-no-block": "",
                      style: {"vertical-align":"-0.125em"},
                      alt: entry.content
                    }, null, 8 /* PROPS */, _hoisted_3))
                  : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          }), 256 /* UNKEYED_FRAGMENT */)),
          (dropdown.value && !__props.mobile)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" >")
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */),
        (dropdown.value)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: _normalizeClass([
                    _ctx.$style['expand-indicator'],
                    __props.expanded ? _ctx.$style['expanded'] : _ctx.$style['collapsed'],
                ])
            }, "❯", 2 /* CLASS */))
          : _createCommentVNode("v-if", true),
        (
                    !dropdown.value &&
                    !__props.columnItem &&
                    !__props.showSubItemsInColumn &&
                    __props.menuItem?.count != null
                )
          ? (_openBlock(), _createElementBlock("span", {
              key: 2,
              class: _normalizeClass([_ctx.$style['item-count']])
            }, "(" + _toDisplayString(__props.menuItem.count) + ")", 3 /* TEXT, CLASS */))
          : _createCommentVNode("v-if", true)
      ], undefined, true),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["href", "class", "target"])),
    (!__props.disableItems)
      ? (_openBlock(), _createBlock(FadeAndSlide, { key: 0 }, {
          default: _withCtx(() => [
            (
                    __props.menuItem?.items != null &&
                    __props.menuItem.items.length > 0 &&
                    ((dropdown.value && __props.expanded) ||
                        (__props.dropdownItem && __props.showSubItemsInColumn))
                )
              ? (_openBlock(), _createBlock(Items, {
                  key: 0,
                  dropdown: dropdown.value,
                  mobile: __props.mobile,
                  "parent-item": __props.menuItem,
                  "menu-items": __props.menuItem.items,
                  "parent-last": __props.last,
                  "show-as-column": __props.dropdownItem && __props.showSubItemsInColumn,
                  "one-per-column-layout": 
                        !__props.mobile &&
                        dropdown.value &&
                        _unref(isMulticolumnDropdownContainer)(__props.menuItem)
                    ,
                  level: __props.level + 1
                }, null, 8 /* PROPS */, ["dropdown", "mobile", "parent-item", "menu-items", "parent-last", "show-as-column", "one-per-column-layout", "level"]))
              : _createCommentVNode("v-if", true)
          ], undefined, true),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}
}

})